/**
=========================================================
* Trakib - v2.1.0
=========================================================

* Product Page: https://www.trakib.com/product/material-dashboard-pro-react
* Copyright 2022 Trakib (https://www.trakib.com)

Coded by www.trakib.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useContext } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Trakib components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";

// Trakib examples
import DefaultLayout from "examples/LayoutContainers//DefaultLayout";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import { Tooltip, IconButton, Icon } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";

import CrudService from "services/cruds-service";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "context";

import { AbilityContext } from "Can";
import { useAbility } from "@casl/react";
import { Can } from "Can";
import { subject } from "@casl/ability";
import i18n from "i18n";
import DefaultCell from "components/table/DefaultCell";
import { Add } from "@mui/icons-material";

function Tags() {
  const { t } = i18n;
  let { state } = useLocation();
  const [meta, setMeta] = useState(null);
  const [page, setPage] = useState(1);
  const [sortVal, setSortVal] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [items, setItems] = useState([]);
  // const [showFilter, setShowFilter] = useState(false);
  const [limitChange, setLimitChange] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [filterUrl, setFilterUrl] = useState("");
  const [filterData, setFilterData] = useState(false);
  // const [notification, setNotification] = useState({
  //   value: false,
  //   text: "",
  // });
  let { pathname } = useLocation();
  let route = pathname.split("/")[pathname.split("/").length - 1];

  const reqUrl = `items/${route}?fields=id,type,translations.*&page=${page}`;
  const navigate = useNavigate();
  const ability = useAbility(AbilityContext);
  const authContext = useContext(AuthContext);

  useEffect(() => {
    (async () => {
      setIsAdmin(await authContext.isCurrentUserAdmin());
    })();
  }, []);

  const getItems = async (filUrl) => {
    const response = await CrudService.getData(`${reqUrl}${filUrl}`);
    setItems(response.data);
    setMeta(response.meta);
  };

  useEffect(() => {
    if (limitChange) {
      setLimitChange(false);
      return; //to avoid do request two time when it true and false ;now it do only one time when it return to false
    }

    if (filterData) {
      setFilterData(false);
      return; //to avoid do request two time when it true and false ;now it do only one time when it return to false
    }

    let sortUrl = "";
    if (sortVal) {
      sortUrl = `&sort=${sortVal.desc ? "-" : "+"}${sortVal.id}`;
    }
    getItems(`${filterUrl}${sortUrl}`);
  }, [page, limitChange, sortVal, filterData, route]);

  useEffect(() => {
    if (page !== 1) setPage(1);
    else if (filterUrl !== "") setFilterData(true); // to do any action to fire useEffect which fire when filterData chenged to do getItems function and aproove that sort value exist
  }, [filterUrl]);

  // useEffect(() => {
  //   if (!state) return;
  //   setNotification({
  //     value: state.value,
  //     text: state.text,
  //   });
  // }, [state]);

  // useEffect(() => {
  //   if (notification.value === true) {
  //     setTimeout(() => {
  //       setNotification({
  //         value: false,
  //         text: "",
  //       });
  //     }, 5000);
  //   }
  // }, [notification]);

  const clickAddHandler = () => {
    navigate(`/settings/add/${route}`);
  };

  const clickEditHandler = (id) => {
    navigate(`/settings/update/${route}/${id}`);
  };

  const setFilterTxt = (txt) => {
    const filter = txt ? `&filter[translations][name][_contains]=${txt}` : null;
    console.log(filter ? "s" : "n");

    filter ? setFilterUrl(filter) : getItems("");
  };

  const getRows = (info) => {
    let updatedInfo = info.map((row) => {
      return {
        id: row.id,
        name: row.translations[0]?.name || "",
        type: row.type === "a" ? "مقالات" : "faq",
      };
    });
    return updatedInfo;
  };

  useEffect(() => {
    setTableData(getRows(items));
  }, [items]);

  const dataTableData = {
    columns: [
      {
        Header: "الاسم",
        accessor: "name",
        width: "80%",
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "النوع",
        accessor: "type",
        width: "15%",
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "الإجراءات",
        disableSortBy: true,
        accessor: "",
        Cell: (info) => {
          return (
            <MDBox display="flex" alignItems="center">
              {(ability.can("edit", route) || isAdmin) && (
                <MDButton
                  sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                  variant="outlined"
                  color={"info"}
                  size="medium"
                  iconOnly
                  onClick={() => clickEditHandler(info.cell.row.original.id)}
                >
                  <Icon sx={{ fontWeight: "bold" }}>edit</Icon>
                  &nbsp;
                  <Tooltip title="عرض التفاصيل">
                    <span>عرض التفاصيل</span>
                  </Tooltip>
                </MDButton>
              )}
            </MDBox>
          );
        },
      },
      ,
    ],
    rows: tableData,
  };

  return (
    <DefaultLayout>
      {/* {notification.value && (
        <MDAlert color="info" my="20px">
          <MDTypography variant="body2" color="white">
            {notification.text}
          </MDTypography>
        </MDAlert>
      )} */}
      <MDBox pt={3} pb={3} mb={3}>
        {/* <Card> */}
        <MDBox
          p={3}
          lineHeight={1}
          display="flex"
          justifyContent="space-between"
        >
          <MDTypography variant="h5" fontWeight="medium" color="info">
            {t(route)}
          </MDTypography>
          <MDBox display="flex">
            {(ability.can("create", route) || isAdmin) && (
              // <IconButton size="large" onClick={clickAddHandler}>
              //   <Add color="info" />
              // </IconButton>
              <MDButton
                onClick={clickAddHandler}
                variant="outlined"
                color={"info"}
                size="medium"
                iconOnly
                sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
              >
                <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                &nbsp;
                <Tooltip title=" إضافة جديد">
                  <span>إضافة جديد </span>
                </Tooltip>
              </MDButton>
            )}
          </MDBox>
        </MDBox>
        <MDBox display="flex" alignItems="center" justifyContent="center">
          <MDBox width={"60%"}>
            <DataTable
              canSearch={true}
              filterTxt={setFilterTxt}
              setLimitChange={setLimitChange}
              table={dataTableData}
              meta={meta}
              setPage={setPage}
              setSortVal={setSortVal}
              pageNum={page}
              isSorted={false}
            />
          </MDBox>
        </MDBox>

        {/* </Card> */}
      </MDBox>
    </DefaultLayout>
  );
}

export default Tags;
